import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

export default function PaymentError() {
  const navigate = useNavigate();

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-danger bg-opacity-10 px-3">
      <div className="card shadow-lg border-0 rounded-4 text-center p-4">
        <div className="card-body">
          <FontAwesomeIcon icon={faTimesCircle} className="text-danger display-1 mb-3" />
          <h1 className="h3  text-danger">Payment Failed/Cancelled</h1>
          <p className="text-muted">
            Something went wrong. If money was deducted, please contact support or try again.
          </p>
          <button
            onClick={() => navigate('/contact-us')}
            className="btn btn-secondary mt-3 px-4 me-4"
            >
            Contact Support
            </button>
          <button
            onClick={() => navigate('/')}
            className="btn btn-primary mt-3 px-4"
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
}
